<h1>Page Header should be an <code>&lt;h1&gt;</code></h1>

<p-tabs [(value)]="currentTab">
  <p-tablist>
    <p-tab value="tab1">
      Tabs are good
    </p-tab>
    <p-tab value="tab2">
      for in-page navigation.
    </p-tab>
    <p-tab value="tab3">
      At the top of the page,
    </p-tab>
    <p-tab value="tab4">
      they go outside a card.
    </p-tab>
  </p-tablist>
</p-tabs>

@switch (currentTab) {
  @case('tab1') {
    <p-card>Prefer to use router navigation at the top level of a page.</p-card>
  }
  @case('tab2') {
    <p-card>Content for Tab 2</p-card>
  }
  @case('tab3') {
    <p-card>Content for Tab 3</p-card>
  }
  @case('tab4') {
    <p-card>Content for Tab 4</p-card>
  }
}

<p-steps #steps [model]="stepItems">
  <ng-template pTemplate="item" let-item let-i="index">
      <div style="position: relative; text-align: center; min-width: 10em">
        <div class="ui-menuitem-text">
          {{item.label}}
        </div>
      </div>
  </ng-template>
</p-steps>


<div class="p-grid" >
  <div class="p-col-12 p-md-6 p-lg-4">
    <p-card header="Basic Text">
      <p>This is a paragraph. <a href="#">This is a link.</a></p>
      <p class="text-small">This is small text.</p>
      <p class="text-deemphasized">This is deemphasized text.</p>
    </p-card>
  </div>
  <div class="p-col-12 p-md-6 p-lg-4">
    <p-card header="Card">
      <p>Pages should be broken up into sections using the <code>&lt;p-card&gt;</code> component. Generally, use the <code>header</code> property to give each card a title.</p>
      <ng-template pTemplate="footer">
        <button pButton severity="secondary" label="buttons go in the footer template"></button>
        <button pButton label="primary action goes on the right"></button>
      </ng-template>
    </p-card>
  </div>
  <div class="p-col-12 p-md-6 p-lg-4">
    <p-card>
      <ng-template pTemplate="title">
        <div>
          Card titles can be customized
        </div>
        <button pButton class="p-button-sm">
          with the `title` template.
        </button>
      </ng-template>

      👇 (you can use an <code>&lt;hr&gt;</code> to separate sections)

      <ng-template pTemplate="footer">
        <button pButton label="Action buttons go in card footers" icon="pi pi-plus"></button>
      </ng-template>
    </p-card>
  </div>
</div>

<hr>

<div class="p-grid">
  <div class="p-col-12 p-lg-4">
    <p-card header="Inline Messages">
      <p>
        <p-message severity="info">Info message</p-message>
        <p-message severity="warn">Warning message</p-message>
        <p-message severity="error">Error message</p-message>
        <p-message severity="success">Success message</p-message>
      </p>
    </p-card>
    <p-card header="Block Messages">
      <div class="padblk"><p-message severity="info">Info message</p-message></div>
      <div class="padblk"><p-message severity="warn">Warning message</p-message></div>
      <div class="padblk"><p-message severity="error">Error message</p-message></div>
      <div class="padblk"><p-message severity="success">Success message</p-message></div>
    </p-card>
  </div>
  <div class="p-col-12 p-lg-4">
    <p-card header="Colors">
      <p>A range of colors are defined for use in the site.</p>
      <div class="p-grid">
        <div class="p-col" style="background-color: var(--brand-color); color: var(--text-light)">--brand-color</div>
        <div class="p-col" style="background-color: var(--brand-secondary); color: var(--text-light)">--brand-secondary</div>
      </div>
      <div class="p-grid">
        <div class="p-col" style="background-color: var(--primary-darker); color: var(--text-light)">--primary-darker</div>
        <div class="p-col" style="background-color: var(--primary-dark); color: var(--text-light)">--primary-dark</div>
        <div class="p-col" style="background-color: var(--primary-moderate); color: var(--text-light)">--primary-moderate</div>
        <div class="p-col" style="background-color: var(--primary-light); color: var(--text-light)">--primary-light</div>
        <div class="p-col" style="background-color: var(--primary-lighter); color: var(--text-light)">--primary-lighter</div>
      </div>
      <div class="p-grid">
        <div class="p-col" style="background-color: var(--success-darker); color: var(--text-light)">--success-darker</div>
        <div class="p-col" style="background-color: var(--success-dark); color: var(--text-light)">--success-dark</div>
        <div class="p-col" style="background-color: var(--success-moderate); color: var(--text-light)">--success-moderate</div>
        <div class="p-col" style="background-color: var(--success-light); color: var(--text-light)">--success-light</div>
        <div class="p-col" style="background-color: var(--success-lighter); color: var(--text-light)">--success-lighter</div>
      </div>
      <div class="p-grid">
        <div class="p-col" style="background-color: var(--warning-darker); color: var(--text-light)">--warning-darker</div>
        <div class="p-col" style="background-color: var(--warning-dark); color: var(--text-light)">--warning-dark</div>
        <div class="p-col" style="background-color: var(--warning-moderate); color: var(--text-light)">--warning-moderate</div>
        <div class="p-col" style="background-color: var(--warning-light); color: var(--text-light)">--warning-light</div>
        <div class="p-col" style="background-color: var(--warning-lighter); color: var(--text-dark)">--warning-lighter</div>
      </div>
      <div class="p-grid">
        <div class="p-col" style="background-color: var(--danger-darker); color: var(--text-light)">--danger-darker</div>
        <div class="p-col" style="background-color: var(--danger-dark); color: var(--text-light)">--danger-dark</div>
        <div class="p-col" style="background-color: var(--danger-moderate); color: var(--text-light)">--danger-moderate</div>
        <div class="p-col" style="background-color: var(--danger-light); color: var(--text-light)">--danger-light</div>
        <div class="p-col" style="background-color: var(--danger-lighter); color: var(--text-light)">--danger-lighter</div>
      </div>
      <div class="p-grid">
        <div class="p-col" style="background-color: var(--gray-1); color: var(--text-light)">--gray-1</div>
        <div class="p-col" style="background-color: var(--gray-2); color: var(--text-light)">--gray-2</div>
        <div class="p-col" style="background-color: var(--gray-3); color: var(--text-light)">--gray-3</div>
        <div class="p-col" style="background-color: var(--gray-4); color: var(--text-light)">--gray-4</div>
        <div class="p-col" style="background-color: var(--gray-5); color: var(--text-dark)">--gray-5</div>
        <div class="p-col" style="background-color: var(--gray-6); color: var(--text-dark)">--gray-6</div>
        <div class="p-col" style="background-color: var(--gray-7); color: var(--text-dark)">--gray-7</div>
        <div class="p-col" style="background-color: var(--gray-8); color: var(--text-dark)">--gray-8</div>
      </div>
    </p-card>
  </div>
  <div class="p-col-12 p-lg-4">
    <p-card header="Toasts">
      <p>Use <code>MessageService.add()</code> to show toast messages. Make sure you use the MessageService in the shared project, NOT the
        PrimeNG MessageService.
      </p>
      <p>
        Make sure to set the <code>summary</code> and <code>detail</code> properties for each message.
        The <code>data</code> property can additionally have <code>text</code>, <code>list</code>, and <code>button</code> properties:
      </p>
      <code><pre>
const validDataFields: {{'{'}}
  text?: string;
  list?: string[];
  button?: {{'{'}}
    label: string;
    action: () => void;
  {{'}'}}
{{'}'}}
        </pre></code>
      <ng-template pTemplate="footer">
        <button pButton label="Show Info Toast" (click)="showToast()"></button>
        <button pButton label="Show Success Toast" severity="success" (click)="showToast('success')"></button>
        <button pButton label="Show Warn Toast" severity="warn" (click)="showToast('warn')"></button>
        <button pButton label="Show Error Toast" severity="danger" (click)="showToast('error')"></button>
      </ng-template>
    </p-card>
  </div>
</div>

<div class="p-grid">
  <div class="p-col-12 p-md-8 p-xl-6">
    <p-card header="Buttons">
      <p>
        Use <code>&lt;button pButton&gt;</code> for actions.
        Different styles can be indicated using the <code>severity</code> property or a CSS class.
        Add the `.p-button-sm` class for a smaller button size.
      </p>
      <p-table [value]="buttonTableData">
        <ng-template pTemplate="header">
          <tr>
            <th colspan="6" style="text-align: right;">
              In a table, "button action" columns should have an empty header cell unless necessary.
              <i class="pi pi-arrow-down"></i>
            </th>
          </tr>
          <tr>
            <th>Button Type</th>
            <th>Usage</th>
            <th>severity</th>
            <th>CSS class</th>
            <th></th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{row.buttonType}}</td>
            <td>{{row.usage}}</td>
            <td>{{row.severity}}</td>
            <td>{{row.cssClass}}</td>
            <td>
              <button type="button" pButton [label]="row.buttonType" [severity]="row.severity" [icon]="row.icon"></button>
            </td>
            <td>
              <button type="button" pButton [title]="row.buttonType" [severity]="row.severity" [icon]="row.onlyIcon ?? row.icon"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="6" style="text-align: right;">
              Icon Buttons can be used in tables when space is limited. Make sure to set the <code>title</code> attribute for accessibility.
              <i class="pi pi-arrow-up"></i><br>
              You can "stack" multiple icon buttons in one cell, but set <code>white-space: nowrap;</code> on the cell to prevent wrapping.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
  <div class="p-col-12 p-md-8 p-xl-6">
    <p-card header="Form Elements">
      <p>Form Labels should generally go above the input fields, though in certain rare situations they can be placed beside the input fields for better alignment.</p>

      <div class="p-grid">
        <div class="p-col">
          <label for="input1">Label above input</label>
          <input id="input1" type="text" pInputText placeholder="inputs should use the pInputText directive for consistent styling">
        </div>
        <div class="p-col">
          <label for="input1" class="required">Labels for required fields should have the <code>required</code> class</label>
          <input id="input1" type="text" pInputText required [formControl]="requiredField">
          <error-block [field]="requiredField" [messages]="{ required: 'use &lt;error-block&gt; below a field for validation error messages.' }">
          </error-block>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col">
          <label for="select">Use <code>&lt;p-select&gt;</code> for dropdowns.</label>
          <p-select id="select" [options]="selectOptions" placeholder="Always use appendTo=&quot;body&quot;" appendTo="body"></p-select>
        </div>
        <div class="p-col">
          <label for="cal">Use <code>&lt;p-datepicker&gt;</code> for date selection.</label>
          <p-datepicker id="cal" placeholder="Generally, use showIcon=&quot;true&quot; to show the button" showIcon="true" appendTo="body"></p-datepicker>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col">
          <label for="inputgroup">Use <code>&lt;div class=&quot;p-inputgroup&quot;&gt;</code> for grouped inputs and buttons.</label>
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">https://</span>
            <input type="text" pInputText id="inputgroup" placeholder="example.com">
            <button pButton icon="pi pi-check"></button>
          </div>
        </div>
        <div class="p-col">
          <label for="check">Use <code>&lt;p-checkbox&gt;</code> for checkboxes.</label>
          <label>
            <p-checkbox id="check" binary="true"></p-checkbox>
            labels can go above or around.
          </label>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col">
          <label>Use <code>&lt;p-radioButton&gt;</code> for radio buttons.</label>
          <label>
            <p-radioButton id="radio1" name="radiogroup" value="Option 1" [formControl]="radioGroup"></p-radioButton>
            Option 1
          </label>
          <label>
            <p-radioButton id="radio2" name="radiogroup" value="Option 2" [formControl]="radioGroup"></p-radioButton>
            Option 2
          </label>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <button pButton label="Save buttons go in card footers" icon="pi pi-plus" severity="success"></button>
      </ng-template>
    </p-card>
    <p-card>
      <ng-template pTemplate="footer">
        <button pButton label="if your form spans multiple cards," severity="secondary"></button>
        <button pButton label="you can use a new card for buttons" icon="pi pi-check"></button>
      </ng-template>
    </p-card>
  </div>
</div>

<div class="p-grid">
  <div class="p-col-12 p-xl-6">
    <p-card header="Tables">
      <p>
        <code>&lt;p-table&gt;</code> should normally be used for tabular data. You can use the <code>pSortableColumn</code> directive and
        <code>&lt;p-sortIcon&gt;</code> component to make columns sortable. &lt;p-table&gt; also has built-in support for pagination.
        A table-wide filter may be added in the header, or column-specific filters may be added to a second row in the header.
      </p>
      <p-table [value]="tabledatafiltered | async" [paginator]="true" [rows]="10">
        <ng-template pTemplate="caption">
          <div class="p-grid">
            <div class="p-col p-lg-6">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                <input type="text" pInputText placeholder="Search" [formControl]="tablesearch">
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="col1">Column 1 <p-sortIcon field="col1"></p-sortIcon></th>
            <th pSortableColumn="col2">Column 2 <p-sortIcon field="col2"></p-sortIcon></th>
            <th pSortableColumn="col3">Column 3 <p-sortIcon field="col3"></p-sortIcon></th>
            <th></th>
          </tr>
          <tr [formGroup]="tablecolfilters">
            <th><input type="text" pInputText placeholder="Column 1 Filter" formControlName="col1"></th>
            <th><input type="text" pInputText placeholder="Column 2 Filter" formControlName="col2"></th>
            <th><input type="text" pInputText placeholder="Column 3 Filter" formControlName="col3"></th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.col1 }}</td>
            <td>{{ row.col2 }}</td>
            <td>{{ row.col3 }}</td>
            <td>
              <button pButton icon="pi pi-search" title="View details"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <th><input type="text" pInputText placeholder="Table Footers"></th>
            <th><input type="text" pInputText placeholder="can have"></th>
            <th><input type="text" pInputText placeholder="'add' forms"></th>
            <th>
              <button pButton label="Add" icon="pi pi-plus" severity="success"></button>
            </th>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
  <div class="p-col-12 p-xl-6">
    <p-card header="Tables">
      <p>
        If needed for performance, you can fall back to a regular HTML <code>&lt;table&gt;</code>. Styles should work, but you will need to
        manually implement any additional features.
      </p>
      <table>
        <thead>
          <tr>
            <th>Column 1</th>
            <th>Column 2</th>
            <th>Column 3</th>
          </tr>
        </thead>
        <tbody>
          @for (row of tabledata; track $index) {
            <tr>
              <td>{{ row.col1 }}</td>
              <td>{{ row.col2 }}</td>
              <td>{{ row.col3 }}</td>
            </tr>
          }
        </tbody>
      </table>
    </p-card>
  </div>
</div>
